import "moment/locale/it"
import { Col, Row } from "react-bootstrap"
import { Passes } from "@components/CompetitionSeasonStats/Passes/Passes"
import { PlayerFouls } from "@components/CompetitionSeasonStats/PlayerFouls/PlayerFouls"
import { PlayerMinutesGoalkeeper } from "@components/CompetitionSeasonStats/PlayerMinutesGoalkeeper/PlayerMinutesGoalkeeper"

export function PlayerCompetitionSeasonStatsGoalkeeper({
  passes,
  shortPasses,
  longPasses,
  percentagePasses,
  fouls,
  concededFouls,
  redCards,
  yellowCards,
  minutes,
  concededGoals,
  savedPenalties,
  ducks,
  saves,
}: {
  passes: number
  shortPasses: number
  longPasses: number
  percentagePasses: number
  fouls: number
  concededFouls: number
  redCards: number
  yellowCards: number
  minutes: number
  concededGoals: number
  savedPenalties?: number
  ducks: number
  saves: number
}) {
  return (
    <Col>
      <PlayerMinutesGoalkeeper
        minutes={minutes}
        saves={saves}
        concededGoals={concededGoals}
        savedPenalties={savedPenalties}
        ducks={ducks}
      />

      <Row>
        <Col md={6}>
          <Passes
            passes={passes}
            shortPasses={shortPasses}
            longPasses={longPasses}
            percentagePasses={percentagePasses}
          />
        </Col>
        <Col md={6}>
          <PlayerFouls fouls={fouls} concededFouls={concededFouls} redCards={redCards} yellowCards={yellowCards} />
        </Col>
      </Row>
    </Col>
  )
}
